export const COMPONENTS_ENUM = {
    USERS: 'USERS',

    TAGS_MENTIONS: 'TAGS_MENTIONS',
    POST_CHART: 'POST_CHART',
    METADATA: 'METADATA',
    HASHTAGS: 'HASHTAGS',
    COMMENTS: 'COMMENTS',
    PRODUCTS: 'PRODUCTS',
} as const;

export type Components = (typeof COMPONENTS_ENUM)[keyof typeof COMPONENTS_ENUM];
